__webpack_require__.p = "https://capitalmarketsresource.com/";